import { Injectable, Inject, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiLibs } from '@libs/config/api-library';
import { catchError, timeout } from 'rxjs/operators';
import { firstValueFrom, of } from 'rxjs';
import { ConfigInterface, CONFIG_OPTIONS } from '@libs/config/config-options';
import { FactoryService } from './factory.service';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class AcpService {
    public language: string;
    public acpData: any;
    public allResource: any;
    private mediaData: any;// acp media(imgs/video) resource
    public toggles: any;
    public comSer: any;
    public fetchedAcp: boolean = false;

    constructor(
        private http: HttpClient,
        private factorySer: FactoryService,
        injector:Injector,
        @Inject(CONFIG_OPTIONS) private configOptions: ConfigInterface,
    ) {
        this.initLanguage();
        // 解决循环引用，当acp接口报错时，错误页使用默认信息
        let timmer = setTimeout(() => {
            this.comSer = injector.get(CommonService);
            clearTimeout(timmer);
            timmer = null;
        }, 0);
    }

    async initLanguage() { 
        this.language = await this.factorySer.getLanguage();
    }

    async initResource(acpKey: string, allFlag?: boolean) {
        let params = [];
        switch (acpKey) { 
            case 'visitor':
                params = ['frequentContact', 'entryPoint'];
                break;
            case 'license':
                params = ['carPlate'];
                break;
            case 'member':
                params = ['member'];
                break;
            default:
                break;
        }
        const list = ['base', 'logout', 'toggles', 'errorPage', ...params];
        const resp = await this.fetchAcp(list, allFlag);
        if (resp && resp?.code === '0' && resp?.data) {
            const data = resp.data;
            sessionStorage.setItem(allFlag ? `allRes.${this.language}` : `comRes.${this.language}`, JSON.stringify(resp.data));
            this.toggles = data?.functionToggles;
            this.setSessionData(data);
            this.allResource = allFlag ? this.acpData : null;
            return data;
        } else {
            console.log('get resource err..', resp);
        }
    }  

    async fetchAcp(list: any, allFlag?: boolean): Promise<any> {
        this.fetchedAcp = allFlag;
        const body = {typeList: list}
        const url = this.configOptions.tykBaseUrl(ApiLibs.getTridionResource);
        return firstValueFrom(this.http.post<any>(url, body)
            .pipe(timeout(10000), catchError(err => of(err))), { defaultValue: '' });
    }

    getSessionAcp(comFlag?: boolean): any { //listFlag=true: to get all acp with realname
        const comResource = JSON.parse(sessionStorage.getItem(`comRes.${this.language}`));
        const allResource = JSON.parse(sessionStorage.getItem(`allRes.${this.language}`));
        const acpData = comFlag ? comResource : (allResource || comResource);        if (acpData && acpData !== 'undefined') { 
            this.setSessionData(acpData)
        }
        return this.acpData;
    }

    setSessionData(acpData: any) {
        this.acpData = {
            ...acpData?.frequentContactTextResource,
            ...acpData?.carplateTextResource,
            ...acpData?.baseTextResource,
            ...acpData?.memberTextResource,
            ...acpData?.logoutTextResource
        };
        this.mediaData = {
            ...acpData?.frequentContactMediaResource,
            ...acpData?.memberMediaResource,
            ...acpData?.carplateMediaResource,
            ...acpData?.baseMediaResource,
            ...acpData?.logoutMediaResource
        };
        this.factorySer.errList = acpData?.errorPage;
        sessionStorage.setItem(`errList.${this.language}`, JSON.stringify(acpData?.errorPage));
    }
    
    acpFormat(key: string) {
        if (!this.acpData) {
            this.acpData = this.getSessionAcp();
        } 
        return key && this.acpData && this.acpData[key.trim()] ? this.acpData[key.trim()] : '';
    }

    public getAcpText(key: string) {
        if (!this.acpData) {
            const data: any = this.getSessionAcp();
            this.acpData = data ? {
                ...data?.frequentContactTextResource,
                ...data?.memberTextResource,
                ...data?.carplateTextResource,
                ...data?.baseTextResource,
                ...data?.logoutTextResource
            } : this.acpData;
        } 
        return key && this.acpData? this.acpData[key]: null;
    }

    public getAcpMedia(key: string, comFlag?: boolean) {
        if (!this.mediaData) {
            const data: any = this.getSessionAcp(comFlag);
            this.mediaData = data ? {
                ...data?.frequentContactMediaResource,
                ...data?.memberMediaResource,
                ...data?.carplateMediaResource,
                ...data?.baseMediaResourcee,
                ...data?.logoutMediaResource
            } : this.mediaData;
        }
        return this.mediaData? this.mediaData[key] : '';
    }
}
